package com.milta.feature.admin.data.repository

import com.milta.feature.admin.data.remote.AdminApi
import com.milta.feature.admin.data.remote.dto.toDomain
import com.milta.feature.admin.domain.entity.AdminAccounts
import com.milta.feature.admin.domain.entity.AdminClaudeUsage
import com.milta.feature.admin.domain.entity.AdminClaudeUsageEvents
import com.milta.feature.admin.domain.entity.AdminClaudeUsagePeriod
import com.milta.feature.admin.domain.entity.AdminOcrAnalysis
import com.milta.feature.admin.domain.entity.AdminPrompt
import com.milta.feature.admin.domain.repository.AdminRepository

// No offline fallback, same reasoning as TeamRepositoryImpl.getMyEnterprise/deleteMyEnterprise —
// a cross-tenant Admin screen is a live, desktop-only read, not a frequently-revisited-offline one.
class AdminRepositoryImpl(private val api: AdminApi) : AdminRepository {
    override suspend fun getAccounts(): Result<AdminAccounts> = runCatching {
        api.getAccounts().toDomain()
    }

    override suspend fun getPrompts(): Result<List<AdminPrompt>> = runCatching {
        api.getPrompts().prompts.map { it.toDomain() }
    }

    override suspend fun updatePrompt(key: String, body: String): Result<AdminPrompt> = runCatching {
        api.updatePrompt(key, body).toDomain()
    }

    override suspend fun resetPrompt(key: String): Result<AdminPrompt> = runCatching {
        api.resetPrompt(key).toDomain()
    }

    override suspend fun getOcrAnalysis(): Result<AdminOcrAnalysis> = runCatching {
        api.getOcrAnalysis().toDomain()
    }

    override suspend fun getClaudeUsage(period: AdminClaudeUsagePeriod): Result<AdminClaudeUsage> = runCatching {
        api.getClaudeUsage(period).toDomain()
    }

    override suspend fun getClaudeUsageEvents(
        accountId: String, period: AdminClaudeUsagePeriod, page: Int, pageSize: Int,
    ): Result<AdminClaudeUsageEvents> = runCatching {
        api.getClaudeUsageEvents(accountId, period, page, pageSize).toDomain()
    }
}
